<template>
  <div class="h-100">

    <div class="slide-out__top select-unit-head">
      <div class="select-unit-head__parent">
        <div class="select-unit-head__parent-head">
          <div class="select-unit-head__parent-title">{{ groupTitle }}</div>
          <div class="select-unit-head__parent-count">
            {{ credits }} / {{ maxCredits + ( isOptionContainer ? extraRequired : 0) }}<span class="select-unit-head__parent-count-label"> points
              selected</span>
          </div>
        </div>
        <div class="progress-bar">
          <div class="progress-bar__current-value" :style="{width: progressBarWidth, background: progressBarColor}"></div>
        </div>
      </div>
    </div>

    <div class="slide-out__body" ref="slideOutBody" id="slideOutBodyTree">

      <div class="slide-out__body-description" v-if="firstLevelContainer.description.length">{{ firstLevelContainer.description }}</div>

      <div v-show="!selectedUnit" class="slide-out__body-content">

        <transition name="fade">
          <div class="overlay-state overlay-state-loading" v-if="loading">
            <div class="overlay-state__body">
              <i class="overlay-state__icon far fa-spinner-third fa-spin"></i>
              <div class="overlay-state__header">Loading unit details</div>
              <div class="overlay-state__content">Please wait...</div>
            </div>
          </div>
        </transition>

        <div class="slide-out__body-subhead mb-2">
          <h4>Add {{ container.title }}</h4>
          <span>{{ containerSelectedCredits }} points selected</span>
        </div>
        <div class="slide-out__body-description" v-if="container.description.length">{{ container.description }}</div>

        <SlideOutContainer :container="container" :location="location" :mandatory="mandatory" :firstLevelTitle="groupTitle" :isFirstLevelContainer="true" />

      </div>

      <SlideOutUnitDetails v-if="selectedUnit && selectedUnitLocation"
        :relationship="selectedUnit" :location="selectedUnitLocation" :firstLevelTitle="groupTitle" :allowEdit="true" v-on:back="deselectUnit"
        :canGoBack="true" verticalGrouping="container.verticalGrouping" />

    </div>

  </div>
</template>

<script>
import SlideOutUnitDetails from './SlideOutUnitDetails.vue'
import SlideOutContainer from './SlideOutContainer.vue'
import SelectionLocationHelper from 'client/js/utils/selection-location-helper.js'
import creditChangeCalculator from 'client/js/utils/credit-change-calculator.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    container: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    mandatory: {
      type: Boolean,
      required: true
    },
    firstLevelContainer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedUnit: null,
      selectedUnitLocation: null,
      loading: false,
      scrollPos: 0,
      fillDefault: '#2372A7',
      fillWarning: '#99600B',
      fillDanger: '#62090E',
      fillSuccess: '#317817'
    }
  },
  computed: {
    ...mapGetters({
      totalCredits: 'units/getTotalCredits'
    }),
    maxCredits() {
      return parseInt(this.firstLevelContainer.credits) || 0
    },
    progressBarWidth() {
      // Turns selected unit points to a % for progress bar
      if (this.isOptionContainer) {
        return (100 / (parseInt(this.firstLevelContainer.credits) + this.extraRequired)) * this.credits + '%'
      }
      return (100 / parseInt(this.firstLevelContainer.credits)) * this.credits + '%'
    },
    progressBarColor() {
      if (this.allUnitsSelected) {
        return this.fillSuccess
      } else if (this.tooManyUnits) {
        return this.fillDanger
      }
      return this.fillDefault
    },
    creditsLocation() {
      return SelectionLocationHelper.getContainerLocation('root', this.firstLevelContainer)
    },
    credits() {
      return this.totalCredits(this.creditsLocation, true)
    },
    containerSelectedCredits() {
      return this.totalCredits(this.location)
    },
    groupTitle() {
      return this.firstLevelContainer.title
    },
    isOptionContainer() {
      if (this.groupTitle == 'Option' || this.groupTitle == 'Options') {
        return true
      }
      return false
    },
    extraRequired() {
      return this.totalCredits('root', true, true) - this.totalCredits('root', false, true)
    },
    allUnitsSelected() {
      if (!this.isOptionContainer && this.credits == this.maxCredits) {
        return true
      } else if (this.isOptionContainer && this.credits == this.maxCredits + this.extraRequired) {
        return true
      }
      return false
    },
    tooManyUnits() {
      if (!this.isOptionContainer && this.credits > this.maxCredits) {
        return true
      } else if (this.isOptionContainer && this.credits > this.maxCredits + this.extraRequired) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapMutations('global', {
      closeSlideOut: 'closeSlideOut'
    }),
    viewUnit(unit, location) {
      this.scrollPos = this.$refs.slideOutBody.scrollTop
      this.selectedUnit = unit
      this.selectedUnitLocation = location
    },
    deselectUnit() {
      this.selectedUnit = null
      this.selectedUnitLocation = null
      this.$refs.slideOutBody.scrollTop = this.scrollPos
    }
  },
  mounted() {
    // subscribe to add tree view listening to display details.
    this.unsubscribeCreditEvents = this.$store.subscribeAction((action, state) => {
      if (action.type === 'userJourney/viewUnit') {
        this.viewUnit(action.payload.relationship, action.payload.location)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribeCreditEvents()
  },
  components: { SlideOutContainer, SlideOutUnitDetails }
}
</script>
